import axios from 'axios';
// import qs from 'qs';
// import mockAdapterJson from './mock-adapter';
// import intl from 'react-intl-universal';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import { ZT_LANGUAGE } from '@src/utils/locale';
// import constants from '@src/constants';
const lang = getLanguageByPath();

axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post['X-Locale'] = ZT_LANGUAGE[lang];
axios.defaults.headers.get['X-Locale'] = ZT_LANGUAGE[lang];
// axios.defaults.headers.post['Host'] = '120.131.0.111';
// axios.defaults.headers.post['Type'] = '0';
// axios.defaults.headers.post['Token'] = '222';

export default class Json {
  static option = {
    baseURL: '',
    withCredentials: true,
    timeout: 10000
    // ...mockAdapterJson
  };

  constructor(option) {
    this.fetch = Json.create(option);
  }

  static create(option) {
    const instance = axios.create({ ...this.option, ...option });
    instance.interceptors.request.use(config => {
      const { data, baseURL, ...otherConfig } = config;
      const { method, requestId, ...restData } = data;
      let params = {};
      if (config.method === 'get') {
        params = {
          params: data
        };
      } else {
        params = {
          data
        };
      }
      return {
        baseURL: `${baseURL}`,
        ...params,
        // data: qs.stringify(restData),
        ...otherConfig
      };
    });

    instance.interceptors.response.use(data => {
      const { config, headers } = data;
      // console.log('response', data);
      // const {method} = JSON.parse(config.data);
      return {
        ...(data.data || {}),
        responseDateTime: new Date(headers.date).getTime()
      };
    });

    return instance;
  }

  /**
   *
   * @param url
   * @param [data]
   * @return {Promise<any>}
   */
  async get(url, data) {
    return this.fetch.get(url, { data }).catch(error => {
      if (error.message === 'Network Error') {
        //error.message = intl.get('SERVICE_NETWORK_ERROR');
        // AntdMessage.error(intl.get('SERVICE_NETWORK_ERROR'));
      } else if (error.code === 'ECONNABORTED') {
        // error.message = intl.get('SERVICE_NETWORK_TIMEOUT');
        // AntdMessage.error(intl.get('SERVICE_NETWORK_TIMEOUT'));
      }
      throw error;
    });
  }

  /**
   *
   * @param url
   * @param [data]
   * @param [config]
   * @return {Promise<any>}
   */
  async post(url, data, config) {
    return this.fetch.post(url, data, config).catch(error => {
      if (error.message === 'Network Error') {
        // error.message = intl.get('SERVICE_NETWORK_ERROR');
        // AntdMessage.error(intl.get('SERVICE_NETWORK_ERROR'));
      } else if (error.code === 'ECONNABORTED') {
        // error.message = intl.get('SERVICE_NETWORK_TIMEOUT');
        // AntdMessage.error(intl.get('SERVICE_NETWORK_TIMEOUT'));
      }
      throw error;
    });
  }
}
